"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
define('controller/organization/list',['require','exports','module','underscore','backbone','marionette','../base','templates','config','langs','model/organization','model/organization.approver','uikit/uikit','view/empty.table','view/table.selected.remove','view/selectable.segment'],function (require, exports, module) {
  var _ = require('underscore');
  var Backbone = require('backbone');
  var Mn = require('marionette');
  var RegionController = require('../base');
  var Templates = require('templates');
  var config = require('config');
  var langs = require('langs');
  var Organization = require('model/organization');
  var OrganizationApprover = require('model/organization.approver');
  var UIKit = require('uikit/uikit');
  var EmptyTable = require('view/empty.table');
  var TableSelectedRemove = require('view/table.selected.remove');
  var SelectableSegment = require('view/selectable.segment');
  var TableNavigation = UIKit.TableNavigation;
  var ButtonView = UIKit.Button;
  var TextView = UIKit.Text;
  var RootView = Mn.ItemView.extend(UIKit.ComponentMixin).extend({
    useInjector: true,
    template: Templates.IRB['organization.list'],
    options: {
      pageTitle: langs.phrase('Settings.OrgApprovers.List.Title')
    }
  });
  var OrganizationApproverList = RegionController.extend({
    header: langs.phrase('App.Title'),
    authorities: ['PERM_IRB_ADMIN'],
    onStart: function onStart() {
      var app = this.app,
        region = this.region,
        state = this.state;
      var root = new RootView(),
        orgs = Organization.all({
          full: true
        }),
        flatOrgs = new Backbone.Collection([], {
          comparator: sortByOrg
        }),
        removedApprovers = new Backbone.Collection(),
        approvers = OrganizationApprover.all(),
        breadcrumb = root.breadcrumb,
        approverTable = root.approverTable,
        addApprover = root.addApproverButton,
        orgTree = root.orgTree,
        orgSearch = root.orgSearch,
        orgTable = root.orgTable,
        orgHeader = new SelectableSegment(),
        approversTitle = root.approversTitle,
        undoButton = root.undoButton,
        navOrg = null;
      var orgSearchTimeout = null;
      root.orgHeader = orgHeader;
      root.$el.css(config.contentCss);
      orgTable.$el.css('margin-top', '0');
      approvers.comparator = function (a) {
        return String(a.get('person.lastName')).toLowerCase();
      };
      orgTable.collection = new Backbone.Collection([]);
      orgTable.selectable = true;
      orgTable.emptyText = 'No Organizations';
      orgTable.selection = 'single';
      orgTree.collection = orgs;
      orgTree.tableOptions.basic = true;
      orgTree.tableOptions.borderless = true;
      approverTable.selectable = true;
      approverTable.selection = 'single';
      approverTable.collection = approvers;
      approverTable.emptyView = EmptyTable.Row;
      approverTable.emptyViewOptions = {
        text: 'No Approvers',
        icon: false
      };
      approverTable.ariaLabelledby = 'orgApproversHeader';
      orgHeader.disabled = true;
      orgTable.columns.set([{
        data: 'title'
      }]);
      approverTable.columns.set([{
        text: 'Name',
        data: 'person.boldHtmlDisplayName'
      }, {
        text: 'Email',
        data: 'person.email'
      }, {
        text: 'Phone',
        data: 'person.phone'
      }, _defineProperty({
        childView: TableSelectedRemove,
        align: 'right',
        collapsing: true
      }, "align", 'right')]);
      orgTree.columns.set([{
        data: true,
        collapsing: true
      }, {
        data: 'title'
      }, TableNavigation.generateNestedIconColumn('children')]);
      breadcrumb.collection = new Backbone.Collection([]);
      function displayHeader(visible) {
        if (visible) {
          orgHeader.visible = true;
        } else {
          orgHeader.visible = false;
        }
      }
      function filterOrgs(org) {
        var text = String(orgSearch.value).toLowerCase();
        if (!text) {
          return false;
        }
        return String(org.get('title')).toLowerCase().indexOf(text) > -1;
      }
      ;
      function sortByOrg(org) {
        return String(org.get('title')).toLowerCase();
      }
      ;
      function addOrgAndChildren(org) {
        var children = org.get('children');
        flatOrgs.add(org);
        if (children) {
          children.each(addOrgAndChildren);
        }
      }
      ;
      function buildOrgTitle(org) {
        var orgs = [],
          o = org;
        while (o && o.get('parentId')) {
          o = flatOrgs.get(o.get('parentId'));
          orgs.unshift(o);
        }
        if (org) {
          orgHeader.text = org.get('title');
          breadcrumb.collection.reset([{
            text: 'All',
            link: true
          }]);
          breadcrumb.$el.parent().show();
        } else {
          breadcrumb.$el.parent().hide();
          orgHeader.text = 'All';
          breadcrumb.collection.reset();
        }
        breadcrumb.collection.add(_.map(orgs, function (org) {
          return {
            text: org.get('title'),
            link: true,
            org: org
          };
        }));
      }
      ;
      function getCurrentRemovedApprovers() {
        var org = orgTree.value,
          approvers = [];
        if (org) {
          approvers = removedApprovers.filter(function (a) {
            return a.get('organizationId') == org.id;
          });
        }
        return approvers;
      }
      function updateUndoState() {
        var approvers = getCurrentRemovedApprovers();
        if (approvers.length > 0) {
          undoButton.disabled = false;
        } else {
          undoButton.disabled = true;
        }
      }
      function importSelectedOrg() {
        if (state.get('orgId')) {
          orgTree.navigateImmediately(flatOrgs.get(state.get('orgId')));
        } else {
          buildOrgTitle();
        }
      }
      root.listenTo(addApprover, 'press', function () {
        var org = orgTree.value,
          title = 'Add approvers to "' + org.get('title') + '"',
          text = 'Added Approvers';
        app.request('personFinderOverlay', {
          ignore: approvers.pluck('person'),
          text: title,
          headerText: text
        }).on('save', function (persons) {
          Promise.map(persons, function (person) {
            return OrganizationApprover.create(person, org).save().promise();
          }, {
            concurrency: 1
          }).then(function () {
            return approvers.fetch().promise();
          })["finally"](app.request('dimmer'));
        });
      }).listenTo(approverTable, 'row:remove:model', _.debounce(function (row) {
        var approver = row.model;
        if (approverTable.value == row.model) {
          approverTable.value = null;
        }
        approver.destroy({
          wait: true
        }).promise().then(function () {
          removedApprovers.push(approver);
        });
      })).listenTo(orgTable, 'change:value', function () {
        if (orgTable.value) {
          orgTree.navigateImmediately(orgTable.value);
        }
      }).listenTo(breadcrumb, 'section:press', function (model, index) {
        var org = model.get('org');
        orgTree.navigatePrevious(org);
      }).listenTo(orgSearch, 'change:value', _.debounce(function () {
        if (orgSearchTimeout) {
          clearTimeout(orgSearchTimeout);
        }
        orgSearchTimeout = setTimeout(function () {
          displayHeader(!orgSearch.value);
          orgTable.collection = new Backbone.Collection([]);
          if (orgSearch.value) {
            orgTable.visible = true;
            flatOrgs.each(function (org) {
              if (filterOrgs(org)) {
                orgTable.collection.add(org);
              }
            });
          } else {
            orgTable.visible = false;
          }
          orgTree.visible = !orgTable.visible;
        }, 1000);
      })).listenTo(orgHeader, 'change:selected', function () {
        if (orgHeader.selected) {
          orgTree.value = navOrg;
        }
      }).listenTo(undoButton, 'press', function () {
        var approver = _.last(getCurrentRemovedApprovers());
        if (approver) {
          removedApprovers.remove(approver);
          approver.save().promise().then(function () {
            approvers.fetch();
          });
        }
      }).listenTo(orgTree, 'change:value', function () {
        var org = orgTree.value;
        orgSearch.value = '';
        orgTable.value = null;
        if (org) {
          state.set('orgId', org.id);
          approvers.params({
            organizationId: org.id
          }).fetch();
          approversTitle.text = 'Approvers for "' + org.get('title') + '"';
          addApprover.disabled = false;
          root.$('#emptyDisplay').hide();
          root.$('#org-approver-container').show().triggerHandler('show');
          if (org.get('children') && org.get('children').length > 0) {
            navOrg = org;
          } else {
            navOrg = flatOrgs.get(org.get('parentId'));
          }
        } else {
          approvers.reset();
          addApprover.disabled = true;
          state.unset('orgId');
          root.$('#emptyDisplay').show();
          root.$('#org-approver-container').hide().triggerHandler('hide');
          navOrg = null;
        }
        approverTable.value = null;
        if (org === navOrg) {
          orgHeader.selected = true;
        } else {
          orgHeader.selected = false;
        }
        if (navOrg) {
          orgHeader.disabled = false;
          orgTree.collection = navOrg.get('children');
        } else {
          orgHeader.disabled = true;
          orgTree.collection = orgs;
        }
        buildOrgTitle(navOrg);
        updateUndoState();
      });
      var _importSelectedOrg = _.after(2, importSelectedOrg);
      root.listenTo(orgs, 'sync', function () {
        orgTree.selected = orgs.at(0);
        orgs.each(addOrgAndChildren);
        _importSelectedOrg();
      }).listenTo(removedApprovers, 'add remove reset', function () {
        updateUndoState();
      }).once('render', _importSelectedOrg);
      state.addPageDependencies([orgs]).on('page:loaded', function () {
        if (orgs.isEmpty()) {} else {
          region.show(root);
        }
      }).on('page:error', function () {}).on('page:cancel', function () {});
      orgs.fetch();
    }
  });
  module.exports = OrganizationApproverList;
});

